























































import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { convertDateLocalToUtc, convertDateUtcToLocal, toStringHHM, toStringYYYYMMDD } from '@/core/DateUtils'
import { BaseVueComponent } from '@/components/BaseVueComponent'

/**
 * Date/time as milliseconds (UTC) should be passed into the value prop via the v-model.
 * While date/time values are passed in and out in UTC, they are displayed to the user
 * using local date/time.
 */
@Component
export default class FormDateTimeField extends BaseVueComponent {
    @Prop({ type: Number })
    value: number|undefined
    @Prop({ type: String })
    label: string|undefined
    @Prop({ type: Boolean, default: false })
    embedLabel: boolean|undefined
    isDateMenuVisible: boolean = false
    isTimeMenuVisible: boolean = false

    getDate(): Date|undefined {
        return (this.value === undefined) ? undefined : convertDateUtcToLocal(new Date(this.value))
    }

    getDateText(): string {
        const date = this.getDate()
        return date ? toStringYYYYMMDD(date) : ''
    }

    getTimeText(): string {
        const date = this.getDate()
        return date ? toStringHHM(date) : ''
    }

    onDateChanged(dateText: string|undefined) {
        this.updateDateTime(dateText, this.getTimeText())
    }

    onTimeChanged(timeText: string|undefined) {
        this.updateDateTime(this.getDateText(), timeText)
    }

    updateDateTime(dateText: string|undefined, timeText: string|undefined) {
        if (timeText && dateText) {
            const localDate = new Date(Date.parse(`${dateText}T${timeText}Z`))
            const utcDate = convertDateLocalToUtc(localDate)
            this.emitValueChanged(utcDate.getTime())
        }
    }
}
